import React from "react";
import { useSelector } from "react-redux";

export function UiFullLoadingSpinner() {
     const loader = useSelector((state) => state.loading);

     return (
          <>
               {loader.show && (
                    <div className="sba-loading-wr">
                         <div className="loader"></div>
                    </div>
               )}
          </>
     );
}

export function SuspenseLoading(props) {
     return (
          <div className="sba-loading-text-wr">
               <div className="sba-loading-text-wr__loader-text">
                    Loading...
               </div>
          </div>
     );
}

export function PageLoader(props) {
     return (
          <>
               {props.show && (
                    <div className="sba-loading-wr">
                         <div className="loader"></div>
                    </div>
               )}
          </>
     ); 
}

export function InnerLoader(props) {
     return (
          <>
               <div className="sba-loading-wr">
                    <div className="loader"></div>
               </div>
          </>
     ); 
}
